import React from "react";
import SignIn from "views/auth/signIn";

const authRoute = [
  {
    key: "user-signUp",
    path: `/client/sign-up`,
    component: React.lazy(() => import("views/auth/signUp")),
    authority: [],
  },
  {
    key: "user-signIn",
    path: `/client/sign-in`,
    component: SignIn,
    authority: [],
  },
   {
    key: "freelancer-auto-login",
    path: `/app/v1/auth/get-freelancer-data`,
    component: React.lazy(() => import("views/auth/getFreelancerData")),
    authority: [],
  },

];

export default authRoute;
